<template lang="pug">
  .card.shadow.mb-4
    .card-header.py-3
      h3.col-11.m-0.font-weight-bold.text-primary Please select a Carrier
      i.nav-item.fas.fa-fw.fa-times.closeModal.pointer(v-if="!gandalf" @click="$emit('closeForm')")
    .card-body
      .row
        .col-lg-6.col-12
          .carrier-card.card.border-left-primary.shadow.py-2(              
            v-bind:class="{active: carrier, selected: fedex.selected}"
            v-on:click="carrierSelect('fedex')"
            )
            .card-body
              img(src="@/assets/img/fedex.png")
              h3 FedEx
        .col-lg-6.col-12
          .carrier-card.card.border-left-primary.shadow.py-2(
              v-bind:class="{active: carrier, selected: ups.selected}"
              v-on:click="carrierSelect('ups')"
              )
            .card-body
              img(src="@/assets/img/ups.png")
              h3 UPS
      transition( name="fade")
        form.col-12.connectCarrier(v-on:submit.prevent="connectFedEx" v-if="carrier=='fedex'")
          .carrier.card.shadow.mb-4
            //- .card-header.py-3
              h3.m-0.font-weight-bold.text-primary() FedEx
            .card-body.carrierCard
              .row
                .col-12.text-right
                  router-link(target="_blank" to="/tutorials/fedexConnection") Launch Tutorial
              .row
                .col-12
                  label Account Number
                  br
                  input.col-lg-6.col-12(type="text" required v-model="fedex.fedexAccountNumber")
              .row
                .col-12
                  label Meter Number
                  br
                  input.col-lg-6.col-12(type="text" required v-model="fedex.fedexMeterNumber")
              .row
                .col-12.text-right
                  button.btn.btn-primary() Connect                  
                .col-12
                  p Note: If you don't have a FedEx Account Number, you can register 
                    a(target="blank" href="https://www.fedex.com/en-us/create-account.html#shipping")
                      strong here
      transition( name="fade")
        form.col-12.connectCarrier(v-on:submit.prevent="connectUPS" v-if="carrier=='ups'")
          .carrier.card.shadow.mb-4
            //- .card-header.py-3
              h3.m-0.font-weight-bold.text-primary() UPS
            .card-body.carrierCard
              .row
                .col-12.text-right
                  router-link(target="_blank" to="/tutorials/UPSConnection") Launch Tutorial
              .row()
                .col-12
                  .row
                    .col-12
                      label UPS.com User ID
                      br
                      input.col-lg-6.col-12(type="text" required v-model="ups.upsUsername")
                  .row                      
                    .col-12
                      label UPS.com Password
                      br
                      input.col-lg-6.col-12(type="password" required v-model="ups.upsPassword")
                  //- .row
                    .col-12.text-right
                      .pointer.btn.btn-primary(v-on:click="ups.step = 2") Next
                .col-12
                  .row
                    .col-12
                      label API Access Key
                      br
                      input.col-lg-6.col-12(type="text" required v-model="ups.upsAccessKey")
                  .row
                    .col-12
                      label Account Number
                      br
                      input.col-lg-6.col-12(type="text" required v-model="ups.upsAccountNumber")
                  .row
                    .col-12.text-right
                      //- .pointer.text-left.btn.btn-primary(style="margin-bottom:10px;" v-on:click="ups.step = 1") Prev
                      button.text-right.btn.btn-primary() Connect
              .row
                .col-12
                  p Note: If you don't have a UPS Account Number, you can register 
                    a(target="blank" href="https://www.ups.com/doapp/signup?loc=en_US&returnto=https:%2F%2Fwww.ups.com%2Fus%2Fen%2FHome.page")
                      strong here

</template>

<script>
// import ''
export default {
  name: 'ConnectCarrier',
  props: {
    gandalf:Boolean,
  },
  data:function(){
    return{

      msg:null,
      carrier:null,      
      fedex:{
        selected:false
      },
      ups:{
        selected:false,
        step:1,
      },
      usps:{
        selected:false
      }
    }
  },
  components:{

  },
  methods:{
    async carrierSelect(carrier){
      this.fedex.selected = false;
      this.ups.selected = false;
      this.usps.selected = false;      
      this.carrier = carrier;
      this[carrier].selected = true;

    },
    async connectUPS(){
      this.flash('Adding Carrier...','success')
      let bodyFormData = new FormData();
      bodyFormData.append('upsUsername', this.ups.upsUsername)
      bodyFormData.append('upsPassword', this.ups.upsPassword)
      bodyFormData.append('upsAccessKey', this.ups.upsAccessKey)
      bodyFormData.append('upsAccountNumber', this.ups.upsAccountNumber)
      let response = await this.axios.post(`/rp/server/connections/ups`,bodyFormData)
      if(response.data.ups_carrier.created_at) {
        this.flash('Carrier Added','success')
        this.$emit('init')
        this.$emit('closeForm')
      }
      
    },
    async connectFedEx(){
      this.flash('Adding Carrier...','success')
      let bodyFormData = new FormData();
      //390771495 acct
      //105573157 meter
      bodyFormData.append('fedexAccountNumber', this.fedex.fedexAccountNumber)
      bodyFormData.append('fedexMeterNumber', this.fedex.fedexMeterNumber)
      let response = await this.axios.post(`/rp/server/connections/fedex`,bodyFormData)
      if(response.data.fedex_carrier.created_at) {
        this.flash('Carrier Added','success')
        this.$emit('init')
        this.$emit('closeForm')
      }
    }
  },
  async created(){    
    

  },
  mounted(){
    document.onkeydown = evt => {
      evt = evt || window.event;
      if (evt.keyCode == 27) {
        this.$emit("closeForm");
      }
    };
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .card{
    width:100%;
  }
  .closeModal{
    position:absolute;
    right:20px;
    top:20px;
  }
  .connectCarrier{
    margin-top:50px;
  }
  .ups2{
    display:flex;
    justify-content:space-between;
  }
  input{
    margin-bottom:30px;
  }
  .container{
    // width:60vw;
    min-height:400px;
  }
  .card-body{
    padding-bottom:60px;
    img{
      height:150px;
    }
    h3{
      margin:10px 0;
    }
  }
  .carrier-card{
    height:250px;
    margin-top:20px;
    transition:height .2s;
    cursor:pointer;
    img{
      height:150px;
    }
    .card-body.selected{
      background-color:rgba(0,0,0,.1);
      
    }  
  }
  .carrier-card.active{
    transition:height .2s;
    height:150px;
    img{
      height:70px;   
    }
  }
  .carrier-card.selected{
    background-color:rgba(0,0,0,.1);
  }
  button{
    // margin-top:50px;
    margin-bottom:10px;
  }
  .carrier{
    margin-top:20px;  
    
  }
  .fade-enter-active {
    transition: opacity .4s;
  }
  .fade-leave-active {
    display:none;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
